(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nublia-installments"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nublia-installments')) {
    customElements.define('nublia-installments', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.schedule = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.root = this.closest('product-info') || [...document.querySelectorAll('product-info')].find(el => el.dataset.url === this.dataset.productUrl);
        if (!this.root) return;
        this.observer = new MutationObserver(records => {
          if (records.some(record => !(record.target.nodeType === 1 ? record.target : record.target.parentElement)?.closest('nublia-installments'))) this.schedule();
        });
        this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'value', 'disabled', 'data-value'] });
        this.root.addEventListener('change', this.schedule, { signal: this.abort.signal });
        this.schedule();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
      parsePrice(price, moneyFormat) {
        const match = price?.match(/[0-9][0-9.,\s\u00a0\u202f\u2019']*/);
        if (!match) return NaN;
        let number = match[0].replace(/[\s\u00a0\u202f\u2019']/g, '');
        const token = moneyFormat?.match(/\{\{\s*(\w+)\s*\}\}/)?.[1];
        const commaDecimal = ['amount_with_comma_separator', 'amount_with_space_separator'].includes(token);
        if (commaDecimal) number = number.replace(/\./g, '').replace(',', '.');
        else if (token) number = number.replace(/,/g, '');
        else {
          const decimal = number.match(/[.,]\d{1,2}$/)?.[0]?.[0];
          number = decimal === ',' ? number.replace(/\./g, '').replace(',', '.') : number.replace(/,/g, '');
        }
        return /^\d+(?:\.\d+)?$/.test(number) ? Number(number) : NaN;
      }
      sync() {
        const content = this.querySelector('.nublia-installments__content');
        const countries = this.dataset.countries.split(',').map(value => value.trim().toUpperCase());
        if (this.dataset.allCountries !== 'true' && !countries.includes(this.dataset.country)) { content.hidden = true; return; }
        const widget = this.root.querySelector('kaching-bundles-block');
        if (widget && this.widget !== widget) {
          this.widget = widget;
          ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(name => widget.addEventListener(name, this.schedule, { signal: this.abort.signal }));
        }
        const button = this.root.querySelector('[id^="ProductSubmitButton-"]');
        if (button?.disabled) { content.hidden = true; return; }
        let price;
        let moneyFormat = this.dataset.moneyFormat;
        let currency = this.dataset.currency;
        if (widget) {
          let config, localization;
          try {
            config = JSON.parse(widget.getAttribute('deal-block') || '{}');
            localization = JSON.parse(widget.getAttribute('config') || '{}');
          } catch { content.hidden = true; return; }
          currency = localization.marketCurrencyCode || currency;
          moneyFormat = localization.moneyFormat || moneyFormat;
          if (currency !== this.dataset.currency) { content.hidden = true; return; }
          if (config.showPricesPerItem || config.showPricesWithoutDecimals || config.priceRounding || config.subscriptionsEnabled) { content.hidden = true; return; }
          price = widget.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price')?.textContent;
        } else {
          price = this.root.querySelector('[id^="main-atc-price-"] [class^="main-atc-price-span-"]')?.textContent;
        }
        const total = this.parsePrice(price, moneyFormat);
        if (!Number.isFinite(total) || total <= 0) { content.hidden = true; return; }
        let formatter;
        try {
          formatter = new Intl.NumberFormat(`${this.dataset.locale}-${this.dataset.country}`, { style: 'currency', currency, currencyDisplay: 'symbol' });
        } catch {
          try { formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency }); }
          catch { content.hidden = true; return; }
        }
        const scale = 10 ** formatter.resolvedOptions().maximumFractionDigits;
        const units = Math.round(total * scale);
        const installment = Math.round(units / 4) / scale;
        const token = moneyFormat?.match(/\{\{\s*(\w+)\s*\}\}/)?.[1];
        const commaDecimal = ['amount_with_comma_separator', 'amount_with_space_separator'].includes(token);
        const group = token?.includes('space') ? ' ' : token?.includes('apostrophe') ? "'" : token?.includes('comma_separator') ? '.' : ',';
        const parts = installment.toFixed(formatter.resolvedOptions().maximumFractionDigits).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
        const number = parts.join(commaDecimal ? ',' : '.');
        const amount = token ? price.trim().replace(/[0-9](?:[0-9.,\s\u00a0\u202f\u2019']*[0-9])?/, () => number) : formatter.format(installment);
        const text = units % 4 ? `${this.dataset.approximate} ${amount}` : amount;
        const target = this.querySelector('[data-bnpl-amount]');
        if (target.textContent !== text) target.textContent = text;
        this.dataset.bundleCents = String(Math.round(total * 100));
        this.dataset.activeCurrency = currency;
        content.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
